import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "about-page" }

import { ref } from "vue";
import { useHead } from '@vueuse/head'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutMe',
  setup(__props) {

const SSRData = ref({
  title: '关于 - 默认代码',
  description: '默认代码,defaultcode.com 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。',
  keywords: '默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区'
})
// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: 'description', content: SSRData.value.description },
    { name: 'keywords', content: SSRData.value.keywords }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "logo-container" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "网站Logo",
        class: "logo"
      })
    ], -1),
    _createElementVNode("div", { class: "content" }, [
      _createElementVNode("p", { class: "description" }, " 宁波开发者技术交流社区，让有意思的人聚在一起。 ")
    ], -1)
  ])))
}
}

})